import { pbx_packages_breadcrumbs } from './packages';
import { pbx_numbers_breadcrumbs } from './numbers';
import { pbx_media_breadcrumbs } from './media';
import { pbx_phone_lists_breadcrumbs } from './phone-lists';
import { pbx_time_conditions_breadcrumbs } from './time-conditions';
import { pbx_operators_breadcrumbs } from './operators';
import { pbx_worksheets_breadcrumbs } from './worksheets';
import { pbx_stats_breadcrumbs } from './stats';

export const pbx_breadcrumbs = [
  ...pbx_packages_breadcrumbs,
  ...pbx_numbers_breadcrumbs,
  ...pbx_media_breadcrumbs,
  ...pbx_phone_lists_breadcrumbs,
  ...pbx_time_conditions_breadcrumbs,
  ...pbx_operators_breadcrumbs,
  ...pbx_worksheets_breadcrumbs,
  ...pbx_stats_breadcrumbs
];
